export class SoundConstants {
    public static LVL_AMBIENT: string = "Lvl_ambient";
    public static WALKBY1: string = "WALKBY1";
    public static BUTTON_CLICK:string = "BUTTON_CLICK";
    //minigames
        public static MINIGAME_ERROR:string = "MINIGAME_ERROR";
        public static MINIGAME_COMPLETE:string = "MINIGAME_COMPLETE";
        public static MINIGAME_LOOSE:string = "MINIGAME_LOOSE";
        //ropes
            public static ROPES_CUTTING:string = "ROPES_CUTTING";
        //engine power up
            public static ENGINE_BUTTON:string = "ENGINE_BUTTON";
            public static ENGINE_TUMBLER:string = "ENGINE_TUMBLER";
        //eco chemistry
            public static ECO_GLASS:string = "ECO_GLASS";
            public static ECO_REAG_USE:string = "ECO_REAG_USE";
            public static ECO_RIGHT_ANWSER:string = "ECO_RIGHT_ANWSER";
            public static ECO_BANG:string = "ECO_BANG";
        //laser
            public static LASER_SOUND:string = "LASER_SOUND";
            public static LASER_MIRROR_CATCH:string = "LASER_MIRROR_CATCH";
            public static LASER_MIRRORING: string = "LASER_MIRRORING";
            public static LASER_MIRROR_PUT:string = "LASER_MIRROR_PUT";
        //icebraker games
            public static ICEBREAKER:string = "ICEBREAKER";
}

export class SoundLevels {
    public static LVL_AMBIENT:number = 0.6;
    public static MINIGAME_AMBIENT: number = 0.6;
    public static WALKING:number = 0.2;
    public static MINIGAME_ACTION:number = 0.8;
    public static UI_ACTION:number = 0.8;
}